module.exports = __webpack_public_path__ + "static/how-remote-7659ca23ab9c591010e9bf30f3b64646.svg";